import React from "react";
import { Shell } from "./shell.jsx";
import { HomeView } from "./home.jsx";
import { StatsView } from "./stats.jsx";
import { StableView } from "./stable.jsx";
import { HorseProfile } from "./profile.jsx";
import { LiveView } from "./live.jsx";
import { InspectView } from "./inspect.jsx";
import { TVView } from "./tv.jsx";
import { AdminView } from "./admin.jsx";

const { useState } = React;

function App() {
  const sections = window.VD.sections || ["home"];
  const requested = new URLSearchParams(location.search).get("tab");
  // Fall back to the first enabled section rather than a view that is switched off.
  const initTab = sections.includes(requested) ? requested : sections[0];
  const [route, setRoute] = useState(initTab);
  const [horseId, setHorseId] = useState(null);
  const [preselect, setPreselect] = useState(null);
  const [stableMode, setStableMode] = useState("draft");

  const go = (target) => {
    if (target.startsWith("horse:")) { setHorseId(target.slice(6)); setRoute("horse"); }
    else if (target.startsWith("inspect:")) { setPreselect(target.slice(8)); setRoute("inspect"); }
    else if (target === "boxes") { setStableMode("boxes"); setRoute("stable"); }
    else { setRoute(target); if (target === "inspect") setPreselect(null); if (target === "stable") setStableMode("draft"); }
  };

  const viewId = (route === "horse") ? "stable" : route;
  const draft = window.DATA.HORSES.filter(h => !h.withdrawn);
  const titles = {
    home:    { eyebrow: `Vendor Dashboard · ${window.DATA.SALE.code || ""}`, title: "Today at Riverside" },
    stats:   { eyebrow: `Repository viewing statistics · ${window.VD.repositoryStats.saleId || ""}`, title: "Vendor Stats" },
    stable:  { eyebrow: `Your draft · ${draft.length} lots`, title: "Stable" },
    horse:   (() => { const h = window.DATA.HORSES.find(x => x.id === horseId);
               return { eyebrow: `Stable · ${h?.sex || ""}`, title: `Lot ${h?.lot || ""}` }; })(),
    live:    { eyebrow: "Parade streams",    title: "Live" },
    inspect: { eyebrow: "Buyer activity",    title: "Inspections" },
    tv:      { eyebrow: "TV control",        title: "Televisions" },
    admin:   { eyebrow: "Access management", title: "Admin" },
  };
  const meta = typeof titles[route] === "function" ? titles[route]() : (titles[route] || titles.home);

  return (
    <Shell view={viewId} setView={(id) => { setHorseId(null); setRoute(id); }}
           title={meta.title} eyebrow={meta.eyebrow}
           onBack={route === "horse" ? () => setRoute("stable") : null}>
      {route === "home"    && <HomeView go={go}/>}
      {route === "stats"   && <StatsView/>}
      {route === "stable"  && <StableView go={go} initialMode={stableMode}/>}
      {route === "horse"   && <HorseProfile horseId={horseId} go={go}/>}
      {route === "live"    && <LiveView/>}
      {route === "inspect" && <InspectView go={go} preselectId={preselect}/>}
      {route === "tv"      && <TVView/>}
      {route === "admin"   && <AdminView/>}
    </Shell>
  );
}

export { App };
